import React, { useState, useContext } from 'react'
import { t } from '@lingui/macro'
import { useTopicForEditQuery } from './TopicEditPage'
import { useDebouncedCallback } from 'use-debounce'
import { usePatchDraftMutation } from '../topic-detail-page/components/settings/operations/patchDraft.codegen'
import { TopicBylineForEditor } from '../topic-detail-page/components/byline/TopicByline'
import { TopicEditingContext } from './TopicEditContext'

export const EditTitleAndSummary = () => {
  const [editing, setEditing] = useState(false)
  const { topic } = useContext(TopicEditingContext)
  const { refetch: refetchTopic } = useTopicForEditQuery()

  const [summary, setSummary] = useState(topic.draftVersion?.summary)
  const [title, setTitle] = useState(topic.draftVersion?.title)
  const [patchDraft] = usePatchDraftMutation()

  const update = useDebouncedCallback(
    async (changedValues: Record<string, unknown>) => {
      await patchDraft({
        variables: {
          topicId: topic.id,
          input: changedValues
        }
      })
      await refetchTopic()
    },
    500
  )

  return (
    <div className="page-content page-content-title">
      <div className="element element-system-generated-title">
        <h1 className="topic-title">
          {editing ? (
            <textarea
              id="title_title"
              placeholder={t`Untitled resource`}
              value={title as string}
              onChange={(e) => {
                const value = e.target.value
                setTitle(value)
                update({ title: value })
              }}
              autoFocus
              onBlur={() => {
                setEditing(false)
              }}
            />
          ) : (
            <span onClick={() => setEditing(true)}>
              {title?.trim() || t`Untitled resource`}
            </span>
          )}
        </h1>

        <TopicBylineForEditor />

        <p className="topic-summary">
          <textarea
            id="title_summary"
            value={summary || ''}
            onChange={(e) => {
              const value = e.target.value
              setSummary(value)
              update({ summary: value })
            }}
            placeholder={t`Add a short summary...`}
          />
        </p>
      </div>
    </div>
  )
}
